import { render, staticRenderFns } from "./LmProcessAllDocuments.vue?vue&type=template&id=2e504074&scoped=true&"
import script from "./LmProcessAllDocuments.vue?vue&type=script&lang=js&"
export * from "./LmProcessAllDocuments.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessAllDocuments.vue?vue&type=style&index=0&id=2e504074&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e504074",
  null
  
)

export default component.exports